module.exports = __webpack_public_path__ + "static/media/warning-triangle.913ae855.svg";